export const trimStringIfAny = (string: string) => {
  return string ? string.trim() : '';
};
